import { Outlet } from 'react-router';
import MainDrawer from 'layout/drawer/Drawer.tsx';
import Toolbar from '@mui/material/Toolbar';
import { Header } from 'layout/header/Header.tsx';
import { useStore } from 'store/store.ts';
import { useMediaQuery, useTheme } from '@mui/material';
import MiniDrawer from './drawer/MiniDrawer.tsx';
import { useLocation } from 'react-router-dom';
import { Fragment } from 'react';
import ConfigSpeedDial from 'components/configSpeedDial/ConfigSpeedDial.tsx';

const omitLayout = ['/canvas'];
const MainLayout = () => {
  const location = useLocation();
  const drawerOpen = useStore().drawerOpen;
  const toggleDrawer = useStore().toggleDrawer;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  if (omitLayout.findIndex((route) => location.pathname.includes(route)) > -1) {
    return (
      <Fragment>
        <Outlet />
      </Fragment>
    );
  }

  return (
    <div className="flex w-full h-screen">
      <div>
        <Header open={drawerOpen} />
      </div>
      {!isSmallScreen && <MainDrawer open={drawerOpen} anchor="left" toggleDrawer={toggleDrawer} resizable={false} />}
      {isSmallScreen && <MiniDrawer open={drawerOpen} />}
      <main className="flex flex-col w-full flex-grow p-4">
        <Toolbar />
        <div className="flex-grow flex justify-center relative">
          <div className="rounded-2xl box-shadow-2xl p-2 w-full max-w-screen-xl">
            <Outlet />
          </div>
        </div>
      </main>
      <ConfigSpeedDial />
    </div>
  );
};

export default MainLayout;
